import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Subscription } from 'rxjs';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { DealerServiceBusinessService } from '../../../business-services/dealer-service.service';
import { DealerServiceDetailsViewModel } from './../../../business-entities/dealer-service-details-view-model';
import { DealerServiceViewModel } from './../../../business-entities/dealer-service-view-model';
import { ServiceViewModel } from './../../../business-entities/service-view-model';
import { ServicesService } from './../../../business-services/services.service';
import { AdminCommonService } from '../../../services/admin-common.service';


@Component({
    selector: 'app-add-dealer-service',
    templateUrl: './add-dealer-service.component.html'
})


export class AddDealerServiceComponent implements OnInit, OnDestroy {

    dealerList: SelectListItemViewModel[];
    selectedDealerId: string;
    languageCode: string;
    currentlagSub: Subscription;
    selectedDealerServices: DealerServiceViewModel[] = [];
    selectedServiceCategoryId: number = -1;
    addDealerServiceForm: FormGroup;
    dealerServiceDetails: DealerServiceDetailsViewModel;
    dealerServiceViewModel: DealerServiceViewModel;
    allServices: ServiceViewModel[] = [];
    allServiceCategory: any[] = [];
    serviceDropdown: { id: number, name: string, serviceNo: string }[] = [];
    price:any;
    selectedService:any;
    selectedServiceCategory:any;
    isFixed:boolean=false;
    isFixedSection:boolean=false;
    FixedPrice:any;
    DealerServicePrice:any;
    DealerServicePriceInclVAT:any;
    dropdownSettings = {};
    selectedDealer:any[]=[];
    VATPercentage:number=0

    constructor(
        private formBuilder: FormBuilder,
        private dealerServiceBusinessService: DealerServiceBusinessService,
        private toastr: ToastrService,
        public currentLanguageService: CurrentLanguage,
        private spinner: NgxSpinnerService, private cookieservice: CookieService,
        private servicesService: ServicesService,
        private globalSetting: GlobalSetting,
        private activeModal : NgbActiveModal,
        private secureStorage: SecureStorage,
        private adminService: AdminCommonService,
        
    ) { }

    ngOnInit(): void {
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'value',
            textField: 'text',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 6,
            allowSearchFilter: false,
            maxHeight: 500
          };

        if (this.currentlagSub) {
            this.currentlagSub.unsubscribe();
          }
        this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
            this.initializeForm();
            this.setDealerDetails();

            });
            this.VATPercentage=this.secureStorage.getKeyData('VATPercentage');
    }

    onDropdownDealerSelected(dealerId: any): void {
        if (dealerId == null) {
          this.selectedDealer = [];
          this.selectedDealerId='';
        } else {
          if (dealerId.length == 0) {
            this.selectedDealer= [];
            this.selectedDealerId=''
          }
          else
          {
            let dealerIdValue='';
            dealerId.forEach(element => {
                dealerIdValue +=element.value + ','
            });
            this.selectedDealerId=dealerIdValue;
          }
        }
      }

    ngOnDestroy(): void {
        this.currentlagSub.unsubscribe();
      }

      onBlur(event) {
        this.DealerServicePrice = event.target.value;
        let priceVal= JSON.parse(JSON.stringify(event.target.value));
        this.DealerServicePriceInclVAT = Utility.GetPriceInludingVAT(priceVal,this.VATPercentage).toString();
      }

      onChecked(obj: any, isChecked: boolean){
        //TODO:
      }

    async initializeForm() {
        if(this.dealerServiceBusinessService.dealerId)
            this.dealerServiceBusinessService.isEdit = true;
        await this.getAllDetails();
        this.addDealerServiceForm = this.formBuilder.group({
            serviceCategory: [-1, [Validators.required, Validators.min(0)]],
            service: [{ value: -1, disabled: true }, [Validators.required, Validators.min(0)]],
            duration: ['', [Validators.required]],
            price: ['', [Validators.required]],
            priceInclVAT: ['', [Validators.required]],
            description: [''],
            isActive: [true],
            isRecommended: [false],
            isDisplayPriceInWidget: [false],
            needAttention:[false]
        });


    }

    async getAllDetails() {
        this.spinner.show();
        this.dealerList = this.dealerServiceBusinessService.dealerList;
        if(this.dealerList.length===1){
            this.selectedDealer = this.dealerList;
        }
        await this.getAllServiceCategories();
        await this.getAllServices();
        this.spinner.hide();
    }

    CheckDuration(event){
        if(event.inputType != 'deleteContentBackward'){
        if(this.addDealerServiceForm.value.duration.length == 2){
          this.addDealerServiceForm.patchValue({
            duration : this.addDealerServiceForm.value.duration + ':',
          })
        }
      }
    }

    async getAllServiceCategories() {
        let language = this.cookieservice.get('userSelectedLanguage')
        await this.servicesService.getServiceCategory(language).then(response => {
            this.allServiceCategory = response.responseObject;
        });
    }

    async getAllServices() {
        let language = this.cookieservice.get('userSelectedLanguage')
        await this.servicesService.getService(language,0,true)
            .then((response) => {
                this.allServices = response;
            });
    }

    async setDealerDetails() {
        let selectedDealerId = this.dealerServiceBusinessService.dealerId;
        if (selectedDealerId && selectedDealerId !== '') {
             await this.onDropdownDealerSelected(selectedDealerId)
        }
    }

    get cpf() {
        return this.addDealerServiceForm.controls;
    }

    isDigit(event): void {
        const isDigit = Utility.isDigit(event);
        if (!isDigit) {
            event.preventDefault();
        }
    }

    onSubmit(): void {
        if (this.addDealerServiceForm.invalid) {
            return;
        }

        let dealerId='';
        this.selectedDealer.forEach(element => {
            dealerId +=element.value + ','
        });
        this.selectedDealerId=dealerId.replace(/,\s*$/, "")

        this.dealerServiceViewModel = this.createViewModal();
        this.spinner.show();
        this.dealerServiceBusinessService.addDealerServices(this.dealerServiceViewModel).then((response) => {
            this.spinner.hide();
            if(response.responseObject?.updatedRows[0])
            {
              if(response.responseObject.updatedRows[0].updatedRowCount)
              {
                this.toastr.success(fromEnums.ToastrMessages.DealerServiceAdded);
                if(response.responseObject.unassociatedChildSrvices
                  && response.responseObject.unassociatedChildSrvices.length>0)
                {
                    const childServiceList = response.responseObject.unassociatedChildSrvices
                        .map(element => element.serviceName)
                        .join(',');
                    this.adminService.showUnassociatedChildServiceWarning(childServiceList)
                }
                this.activeModal.close({ success: true });
              }
              else
              {
                this.toastr.error(fromEnums.ToastrMessages.DealerServiceAddFailed);
              }
            }
        });
    }

    createViewModal(): DealerServiceViewModel {
        const formValue = this.addDealerServiceForm.value;
        const serviceName = this.allServices.find(x => x.id === formValue.service)?.name;
        let duration = Utility.ConvertTimeToMinutes(formValue.duration)
        const serviceCategoryName = this.allServiceCategory.find(x => x.id === formValue.serviceCategory)?.service;
        let dealerId='';
        this.selectedDealer.forEach(element => {
            dealerId +=element.value + ','
        });
        this.selectedDealerId=dealerId.replace(/,\s*$/, "")

        return {
            id: 0,
            dealerId: this.selectedDealerId,
            serviceId: formValue.service,
            duration: duration,
            price: this.globalSetting.getFormattedprice(formValue.price === undefined ? this.DealerServicePrice.toString() : formValue.price.toString()),
            isActive: formValue.isActive,
            name: serviceName,
            description: formValue.description,
            serviceCategoryId: formValue.serviceCategory,
            logo: '',
            isDisplayPriceInWidget: formValue.isDisplayPriceInWidget,
            serviceCategoryName: serviceCategoryName,
            serviceCategoryList: [],
            languageCode:this.cookieservice.get('userSelectedLanguage'),
            needAttention:formValue.needAttention
        } as DealerServiceViewModel;
    }


    onServiceCategorySelected(serviceCategoryId: number) {
        this.addDealerServiceForm.patchValue({
            service:"",
            duration:'',
            price:'',
            priceInclVAT:'',
            description:'',
        })
        this.FixedPrice = '';
        this.isFixedSection = false
        this.selectedServiceCategoryId = serviceCategoryId;
        this.updateSelecteDealerService();
    }
    onServiceSelected(event:any){
        if(event == undefined || event == null){
            this.addDealerServiceForm.patchValue({
                service:"",
                duration:'',
                price:'',
                priceInclVAT:'',
                description:'',
            })
            this.FixedPrice = '';
            this.isFixedSection = false;
            this.isFixed = false;
        }
        else{
            this.isFixedSection = true;
            let id = +event;
            this.addDealerServiceForm.patchValue({price:this.allServices.find(x=>x.id === id).price,
               // duration:this.allServices.find(x=>x.id === id).duration,
                duration:Utility.ConvertMinutesToTime(this.allServices.find(x=>x.id === id).duration.toString()),
                description:this.allServices.find(x=>x.id === id).description,
                needAttention: this.allServices.find(x=>x.id === id).needAttention,
                isRecommended: this.allServices.find(x=>x.id === id).isRecommended,
                isDisplayPriceInWidget:this.allServices.find(x=>x.id === id).displayPriceInWidget
            })
            this.DealerServicePrice=this.allServices.find(x=>x.id === id)?.price;
            if(this.allServices.find(x=>x.id === id).isFixed)
            {
                this.isFixed = true;
                this.FixedPrice = this.DealerServicePrice;
            }
            else{
                this.isFixed = false;
            }
            this.DealerServicePriceInclVAT = this.isFixed ? this.allServices.find(x=>x.id === id).price : Utility.GetPriceInludingVAT(this.allServices.find(x=>x.id === id).price,this.VATPercentage).toString();
            this.addDealerServiceForm.patchValue({
                priceInclVAT:   this.DealerServicePriceInclVAT 
            })
            
        }
    }
    enableServiceDropdown(): boolean {
        let canEnable = false;
        if (this.selectedDealer && this.selectedServiceCategoryId !== -1) {
            this.cpf.service.enable();
            canEnable = true;
        }
        return canEnable;
    }

    updateSelecteDealerService() {
        if (this.enableServiceDropdown()) {
            const servicesOfSelectedCategoryId = this.allServices.filter(x => x.serviceCategoryId === this.selectedServiceCategoryId).map(x => { return { id: x.id, name: x.name,isActive:x.isActive,serviceNo:x.serviceNo } });
            this.serviceDropdown = servicesOfSelectedCategoryId.filter(x => (!this.selectedDealerServices.find(y => y.serviceId === x.id)) &&  x.isActive).map(x=>{return { id: x.id, name: x.name,serviceNo: x.serviceNo}});
        }
    }
    OnClose(){
        this.activeModal.close({success:false})
    }
}
